import { CONFIG } from 'app/core/config';
import { ViewModel } from 'app/viewmodels/view-model';

export class HierarchyTemplateMitigation implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Hierarchy Template Mitigration';
  public readonly apiRoute: string = CONFIG.apiRoutes.hierarchyTemplateMitigations;

  public hierarchyTemplateMitigationId: string;
  public identifier: string;
  public description: string;
  public frequency: string;
  public frequencyUom: string;
  public hierarchyTemplateId: string;
  public taskName: string;
  public mitigationType: string;
  public included: boolean;
  public rowIndex: number;


  json() {
    return this;
  }

  loadFromJson(data) {
    this.hierarchyTemplateMitigationId = data.hierarchyTemplateMitigationId;

    this.identifier = data.identifier;
    this.description = data.description;
    this.frequency = data.frequency;
    this.frequencyUom = data.frequencyUom;
    this.taskName = data.taskName;
    this.included = data.included;
    this.rowIndex = data.rowIndex;
    this.mitigationType = data.mitigationType;


    this.hierarchyTemplateId = data.hierarchyTemplateId;
  }
}

export enum HierarchyFrequencyUomType {
  Days = 1,
  Weeks = 2,
  Months = 3,
  Years = 4
}
